import React from "react";
import { createSvgIcon } from "@mui/material/utils";
const Circle = createSvgIcon(/*#__PURE__*/React.createElement("path", {
  d: "M12,2C6.4771729,2,2,6.4771729,2,12s4.4771729,10,10,10c5.5201416-0.0064697,9.9935303-4.4798584,10-10C22,6.4771729,17.5228271,2,12,2z M12,21c-4.9705811,0-9-4.0294189-9-9s4.0294189-9,9-9c4.9683228,0.0054321,8.9945679,4.0316772,9,9C21,16.9705811,16.9705811,21,12,21z"
}), "Circle");
export default Circle;